import { Routes, Route, Navigate } from "react-router-dom";
import SignIn from "../pages/SignIn/SignIn";
import Profile from "../pages/Profile/Profile";
import CareerManagement from "../pages/JobsManagement/JobsManagement";
import BlogManagement from "../pages/BlogsManagement/BlogsManagement";
import CulturesManagement from "../pages/CulturesManagement/CulturesManagement";
import UserManagement from "../pages/UsersManagement/UsersManagement";
import ContactManagement from "../pages/ContactsManagement/ContactsManagement";
import JobSubmissionsManagement from "../pages/JobsManagement/JobSubmissionsManagement";
import Main from "../components/layout/Main";
import PrivateRoute from "../components/PrivateRoute";
import { ROUTES } from "./constants";
import { useUser } from "../contexts/UserContext";
import { canAccessRoute } from "../utils/permissions";

export const PublicRoutes = () => (
  <Routes>
    <Route path={ROUTES.SIGN_IN} element={<SignIn />} />
  </Routes>
);

export const ProtectedRoutes = () => {
  const { user } = useUser();
  
  const routeConfig = [
    { path: ROUTES.PROFILE, component: Profile, roles: ['admin', 'hr'] },
    { path: ROUTES.JOB_MANAGEMENT, component: CareerManagement, roles: ['admin', 'hr'] },
    { path: ROUTES.JOB_SUBMISSIONS_MANAGEMENT, component: JobSubmissionsManagement, roles: ['admin', 'hr'] },
    { path: ROUTES.CONTACT_MANAGEMENT, component: ContactManagement, roles: ['admin', 'hr'] },
    { path: ROUTES.BLOG_MANAGEMENT, component: BlogManagement, roles: ['admin'] },
    { path: ROUTES.CULTURE_MANAGEMENT, component: CulturesManagement, roles: ['admin'] },
    { path: ROUTES.USER_MANAGEMENT, component: UserManagement, roles: ['admin'] }
  ];

  const accessibleRoutes = routeConfig.filter(route => 
    canAccessRoute(user?.role, route.path)
  );

  return (
    <Routes>
      {accessibleRoutes.map(route => (
        <Route 
          key={route.path}
          path={route.path} 
          element={<route.component />} 
        />
      ))}
      <Route
        path="*"
        element={<Navigate to={ROUTES.JOB_MANAGEMENT} replace />}
      />
    </Routes>
  );
};

export const AppRoutes = () => (
  <Routes>
    <Route path={ROUTES.SIGN_IN} element={<SignIn />} />
    <Route
      path="/*"
      element={
        <PrivateRoute>
          <Main>
            <ProtectedRoutes />
          </Main>
        </PrivateRoute>
      }
    />
  </Routes>
);
